const coreWalletVerificationLevelsForSelection = [
	'EMONEY_NOACTION',
	'EMONEY_BASIC',
	'EMONEY_UNVERIFIED',
	'EMONEY_VERIFIED',
	'EMONEY_BASIC_WITHDRAWAL',
	'EMONEY_PREMIUM',
	'EMONEY_PREMIUM_WITHDRAWAL'
].map(key => {
	return { id: key, name: key };
});

const coreWalletUserStatusForSelection = [
	'CREATED',
	'ACTIVE',
	'BLOCKED',
	'TERMINATED'
].map(key => {
	return { id: key, name: key };
});

export {
	coreWalletVerificationLevelsForSelection,
	coreWalletUserStatusForSelection
};
